import { render, staticRenderFns } from "./FixedBonus.vue?vue&type=template&id=50cee7f2"
import script from "./FixedBonus.vue?vue&type=script&lang=js"
export * from "./FixedBonus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports